<template>
  <ul class="text-grey-80 text-base">
    <li
      class="inline border-r-2 border-grey-30 px-2 first:pl-0 last:border-r-0 last:pr-1"
    >
      Covers: {{ agency.LocationsRecruitedFor }}
    </li>
    <li
      class="inline border-r-2 border-grey-30 px-2 first:pl-0 last:border-r-0 last:pr-1"
    >
      {{ recruitmentTypesText }}
    </li>
    <li
      class="inline border-r-2 border-grey-30 px-2 first:pl-0 last:border-r-0 last:pr-1"
    >
      {{ salariesText }}
    </li>
  </ul>
</template>
<script>
export default {
  name: 'AgencyAdvertRecruitedFor',

  props: {
    agency: { type: Object },
  },
  computed: {
    salariesText() {
      let salaryBreakdown = (this.agency.SalaryBreakdown || '').split(',');

      // The salary breakdown is a string of comma separated numbers that represent
      // the percentage of salary ranges the agencies' job offers cover. eg 10% of jobs
      // are within £15-17k.
      // We find the lowest non-zero number in the string and use it's index find the
      // lower bound of salary options.
      // We then find the highest non-zero number in the string and use it's index to find
      // the upper bound of salary options
      // If all the salaries are in the highest band then the lower text band will be blank,
      // and the text will simply display that salaries are above the highest band
      const lowerBoundOptions = [
        '£15k -',
        '£17k -',
        '£25k -',
        '£35k -',
        '£60k -',
        '',
      ];
      const upperBoundOptions = [
        '£100k+',
        '£100k',
        '£60k',
        '£35k',
        '£25k',
        '£17k',
      ];

      const lowerIndex = salaryBreakdown.findIndex(
        (element) => Number(element) > 0
      );
      salaryBreakdown = salaryBreakdown.reverse();
      const upperIndex = salaryBreakdown.findIndex(
        (element) => Number(element) > 0
      );

      // If the lower index is the last option then the agency only offers salaries over
      // the largest amount, instead of a range, so we remove "from" from the text.
      const salaryTextStart =
        lowerIndex === lowerBoundOptions.length - 1
          ? 'Salaries'
          : 'Salaries from';

      return `${salaryTextStart} ${lowerBoundOptions[lowerIndex]} ${upperBoundOptions[upperIndex]}`;
    },
    recruitmentTypesText() {
      const typeMap = {
        contract: 'Contract',
        permanent: 'Permanent',
        temptoperm: 'Temp to Perm',
        temporary: 'Temporary',
        parttimejobshare: 'Part Time',
      };

      return (this.agency.RecruitmentTypesCovered || '')
        .split(',')
        .map((type) => {
          return Object.keys(typeMap).includes(type) ? typeMap[type] : null;
        })
        .filter((type) => type !== null)
        .join(', ');
    },
  },
};
</script>
